import cs from './cs.json';
import en from './en.json';
import de from './de.json';
import am from './am.json';
import ar from './ar.json';
import az from './az.json';
import be from './be.json';
import bg from './bg.json';
import bi from './bi.json';
import bn from './bn.json';
import bs from './bs.json';
import ca from './ca.json';
import crs from './crs.json';
import da from './da.json';
import dv from './dv.json';
import dz from './dz.json';
import el from './el.json';
import es from './es.json';
import et from './et.json';
import fa from './fa.json';
import fi from './fi.json';
import fj from './fj.json';
import fo from './fo.json';
import fr from './fr.json';
import ga from './ga.json';
import gil from './gil.json';
import gn from './gn.json';
import he from './he.json';
import hi from './hi.json';
import hr from './hr.json';
import ht from './ht.json';
import hu from './hu.json';
import hy from './hy.json';
import id from './id.json';
import is from './is.json';
import it from './it.json';
import ja from './ja.json';
import ka from './ka.json';
import kk from './kk.json';
import kl from './kl.json';
import km from './km.json';
import ko from './ko.json';
import ky from './ky.json';
import lb from './lb.json';
import lo from './lo.json';
import lt from './lt.json';
import lv from './lv.json';
import mg from './mg.json';
import mh from './mh.json';
import mk from './mk.json';
import mn from './mn.json';
import ms from './ms.json';
import mt from './mt.json';
import my from './my.json';
import na from './na.json';
import ne from './ne.json';
import nl from './nl.json';
import no from './no.json';
import ny from './ny.json';
import pau from './pau.json';
import pl from './pl.json';
import ps from './ps.json';
import pt from './pt.json';
import rn from './rn.json';
import ro from './ro.json';
import ru from './ru.json';
import rw from './rw.json';
import sg from './sg.json';
import si from './si.json';
import sk from './sk.json';
import sl from './sl.json';
import sm from './sm.json';
import so from './so.json';
import sq from './sq.json';
import sr from './sr.json';
import ss from './ss.json';
import st from './st.json';
import sv from './sv.json';
import sw from './sw.json';
import tg from './tg.json';
import th from './th.json';
import ti from './ti.json';
import tk from './tk.json';
import tl from './tl.json';
import tn from './tn.json';
import to from './to.json';
import tpi from './tpi.json';
import tr from './tr.json';
import tv from './tv.json';
import uk from './uk.json';
import ur from './ur.json';
import uz from './uz.json';
import vi from './vi.json';
import zh from './zh.json';

export const languages = {
    cs: cs,
    en: en,
    de: de,
    am: am,
    ar: ar,
    az: az,
    be: be,
    bg: bg,
    bi: bi,
    bn: bn,
    bs: bs,
    ca: ca,
    crs: crs,
    da: da,
    dv: dv,
    dz: dz,
    el: el,
    es: es,
    et: et,
    fa: fa,
    fi: fi,
    fj: fj,
    fo: fo,
    fr: fr,
    ga: ga,
    gil: gil,
    gn: gn,
    he: he,
    hi: hi,
    hr: hr,
    ht: ht,
    hu: hu,
    hy: hy,
    id: id,
    is: is,
    it: it,
    ja: ja,
    ka: ka,
    kk: kk,
    kl: kl,
    km: km,
    ko: ko,
    ky: ky,
    lb: lb,
    lo: lo,
    lt: lt,
    lv: lv,
    mg: mg,
    mh: mh,
    mk: mk,
    mn: mn,
    ms: ms,
    mt: mt,
    my: my,
    na: na,
    ne: ne,
    nl: nl,
    no: no,
    ny: ny,
    pau: pau,
    pl: pl,
    ps: ps,
    pt: pt,
    rn: rn,
    ro: ro,
    ru: ru,
    rw: rw,
    sg: sg,
    si: si,
    sk: sk,
    sl: sl,
    sm: sm,
    so: so,
    sq: sq,
    sr: sr,
    ss: ss,
    st: st,
    sv: sv,
    sw: sw,
    tg: tg,
    th: th,
    ti: ti,
    tk: tk,
    tl: tl,
    tn: tn,
    to: to,
    tpi: tpi,
    tr: tr,
    tv: tv,
    uk: uk,
    ur: ur,
    uz: uz,
    vi: vi,
    zh: zh,
};

export type SupportedLanguage = keyof typeof languages;
export const supportedLanguages = Object.keys(languages) as SupportedLanguage[];